module.exports = __webpack_public_path__ + "static/media/app-migration.5dd61425.svg";